import React, { ChangeEventHandler, ReactNode } from 'react';
import { FieldError } from 'react-hook-form';
import { InputWrapper } from '#sign-up/components/shared/InputWrapper';

type Props = React.InputHTMLAttributes<HTMLInputElement> & {
  label: string;
  name: string;
  errors?: FieldError;
  onChange: ChangeEventHandler<HTMLInputElement>;
  icon?: ReactNode;
};

const FormTextField = React.forwardRef<HTMLInputElement, Props>(
  ({ label, name = '', errors, onChange, disabled = false, className, icon, ...props }: Props, ref) => {
    return (
      <InputWrapper name={name} label={label} fieldType="text-field" error={errors} className={className} icon={icon}>
        <input
          id={name}
          name={name}
          type="text"
          ref={ref}
          onChange={onChange}
          aria-invalid={!!errors?.message}
          disabled={disabled}
          {...props}
        />
      </InputWrapper>
    );
  }
);

FormTextField.displayName = 'FormTextField';

export default FormTextField;
